class productCarousels extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const columnsMobile = parseFloat(this.dataset.columnsMobile, 10) || 1;
    const columnsDesktop = parseFloat(this.dataset.columnsDesktop) || 1;
    const productsToShow = parseInt(this.dataset.productsToShow, 10) || 0;

    new Swiper(this.querySelector('.swiper'), {
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
      slidesPerView: columnsMobile,
      spaceBetween: 3,
      // mousewheel: productsToShow > columnsDesktop ? true : false,
      mousewheel: {
        forceToAxis: true
      },
      breakpoints: {
        768: {
          slidesPerView: columnsDesktop === 4 ? 2.8 : columnsDesktop,
        },
        1024: {
          slidesPerView: columnsDesktop + 0.045,
        }
      }
    });
  }
}

customElements.define("product-carousels", productCarousels);